<template>
  <input-select :fieldData="fieldData" :sendPostRule="sendPostRule"></input-select>
</template>

<script>
import InputSelect from '@/components/interactive/InputSelect';
import { inputFieldMixin } from '../../mixins/inputFieldMixin';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'inputType', 'sendPostRule'],
  mixins: [inputFieldMixin],
  components: {
    InputSelect,
  },
  computed: {
    /**
     * Computed and watch 'fieldValue' are triggered when the store's `fields` is updated (for example, from
     * the credit card number field being inputted) which updates this component's `fieldData.field_value`.
     */
    fieldValue() {
      const fields = this.$store.getters.fields || [];
      const fieldRules = this.field_rules || {};
      const creditCardNumberField = fieldRules.creditCardNumberField;
      const matchingField = fields.find(field => field.field_name === creditCardNumberField) || {};

      return matchingField.field_value;
    },
  },
  watch: {
    fieldValue(newValue) {
      const fieldValue = newValue || '';

      // TODO: Use config values
      switch (fieldValue.charAt(0)) {
        case '3':
          this.fieldData.field_value = 'amex';
          break;

        case '4':
          this.fieldData.field_value = 'visa';
          break;

        case '5':
          this.fieldData.field_value = 'mastercard';
          break;

        case '6':
          this.fieldData.field_value = 'discover';
          break;

        default:
          this.fieldData.field_value = '';
          if (fieldValue.charAt(0) !== '') {
            window.console.warn('Unknown credit card type');
          }
          break;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/interactive/InputSelectCreditCardType.vue?83e0ed8a